export default __webpack_public_path__ + "static/media/totalenvio.e4e3d53b.png";